import { i18n } from 'fishx';
import { message } from '@whalecloud/fdx';
import { getMenus, getSonMenus, qryActiveComponentInMenu, delComponent, modComponent } from '@pages/ComponentMgr/services/ComponentMgr';

const handleDirMenus = (data, parent) => {
  if (!data || data.length <= 0) return [];
  const newData = [];
  data.map(item => {
    const result = {
      ...item,
      key: parent ? `${parent.key}.${item.dirId}` : item.dirId.toString(),
      privName: item.dirName,
      type: 'parent',
      children: [],
    };
    if (parent) result.parentId = parent.dirId;
    else if (item.dirId !== -1) result.parentId = -1;
    newData.push(result);
    return newData;
  });
  return newData;
};

const handleSonMenus = (data, parent) => {
  if (!data || data.length <= 0) return [];
  const newData = [];
  const { dirId, key } = parent;
  data.map(item => {
    newData.push({
      ...item,
      parentId: dirId,
      dirId: item.menuId,
      key: `0.${key}.${item.menuId}`,
      type: 'son',
    });
    return newData;
  });
  return newData;
};

const arrayToTree = (array, id = 'dirId', pid = 'parentId', children = 'children') => {
  const data = JSON.parse(JSON.stringify(array));
  const result = [];
  const hash = {};
  data.forEach((item, index) => {
    hash[data[index][id]] = data[index];
  });

  data.forEach(item => {
    const hashVP = hash[item[pid]];
    if (hashVP) {
      if (!hashVP[children]) {
        hashVP[children] = [];
      }
      hashVP[children].push(item);
    } else {
      const itemN = item;
      const { menuId, dirId } = itemN;
      if (dirId !== -1 && (!menuId || menuId === undefined)) {
        itemN.children = [];
      }
      result.push(itemN);
    }
  });
  return result;
};

export default {
  namespace: 'componentMgr',

  state: {
    menuData: [], // 菜单的tree数据结构
    menuDataArr: [], // 菜单的array数据结构
    componentList: [],
  },

  effects: {
    // 获取目录List
    *fetch({ payload }, { call, put }) {
      const { index } = payload;
      const { success, data } = yield call(getMenus, index);
      if (success) {
        yield put({
          type: 'saveMenu',
          payload: {
            data,
          },
        });
      } else {
        yield put({
          type: 'clearState',
        });
      }
    },
    *fetchSon({ payload }, { call, put }) {
      const { record } = payload;
      const { dirId } = record;
      const { success, data } = yield call(getSonMenus, dirId); // data: {dirList: [], menuList: []}
      if (success) {
        yield put({
          type: 'saveMenuSon',
          payload: {
            ...data,
            record,
          },
        });
      }
    },
    *qryActiveComponentInMenu({ payload }, { call, put }) {
      const { menuId } = payload;
      const { success, data } = yield call(qryActiveComponentInMenu, menuId);
      if (success) {
        yield put({
          type: 'save',
          payload: {
            componentList: data,
          },
        });
        return data;
      }
      return null;
    },
    *delComponent({ payload }, { call, put }) {
      const { privId, menuId } = payload;
      const { success } = yield call(delComponent, privId);
      if (success) {
        message.success(
          i18n('COMPONENT_MGR_TIP_DELETE_SUCCESS')
        );
        yield put({
          type: 'qryActiveComponentInMenu',
          payload: {
            menuId,
          },
        });
      }
    },
    *modComponent({ payload }, { call, put }) {
      const { params } = payload;
      const { menuId } = params;
      const { success } = yield call(modComponent, params);
      if (success) {
        message.success(
          i18n('COMPONENT_MGR_TIP_EDIT_SUCCESS')
        );
        yield put({
          type: 'qryActiveComponentInMenu',
          payload: {
            menuId,
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    saveMenu(state, { payload }) {
      // 本地分页
      const { data } = payload;
      const topData = {
        dirId: -1,
        dirName: i18n('COMPONENT_MGR_PORT_MENU_ROOT'),
        type: 'parent',
        ancestor: true,
        children: [],
      };
      data.push(topData);
      const newData = handleDirMenus(data);
      const tree = arrayToTree(newData);
      const params = {
        menuData: tree,
      };
      return {
        ...state,
        menuDataArr: newData,
        ...params,
      };
    },
    saveMenuSon(state, { payload }) {
      const { record, dirList, menuList } = payload;
      const { menuDataArr } = state;
      const { dirId } = record;
      // 首先清空该目录下的子菜单
      const newArr = [];
      menuDataArr.map(item => {
        const { parentId } = item;
        if (!parentId || parentId !== dirId) {
          newArr.push(item);
        }
        return null;
      });

      let listDir = [];
      if (dirList.length > 0) {
        listDir = handleDirMenus(dirList, record);
      }
      let listMenu = [];
      if (menuList.length > 0) {
        listMenu = handleSonMenus(menuList, record);
      }
      const list = newArr.concat(listDir, listMenu);
      const tree = arrayToTree(list);
      return {
        ...state,
        menuDataArr: list,
        menuData: tree,
      };
    },
  },
};
